// This is a quick hack that I will refactor in the future...sorry future self!
export function controlMenuDropdowns() {
  console.log('flare');
  const triggers = document.querySelectorAll(
    '.c-header__desktop__menu__nav__list__item--with-dropdown'
  );

  Array.from(triggers).forEach((trigger) => {
    trigger.addEventListener('mouseenter', (e) => {
      setTimeout(() => {
        if (trigger.parentElement.querySelector(':hover') === trigger) {
          trigger.classList.add('allow-dropdown');
        }
      }, 200);
    });

    trigger.addEventListener('mouseleave', (e) => {
      if (trigger.classList.contains('allow-dropdown')) {
        trigger.classList.remove('allow-dropdown');
      }
    });

    trigger.addEventListener('click', (e) => {
      if (trigger.classList.contains('allow-dropdown')) {
        trigger.classList.remove('allow-dropdown');
      } else {
        trigger.classList.add('allow-dropdown');
      }
    });
  });
}

export default { controlMenuDropdowns };
